import { render, staticRenderFns } from "./ConfirmForgotPassword.vue?vue&type=template&id=42f9bea4"
import script from "./ConfirmForgotPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ConfirmForgotPassword.vue?vue&type=style&index=0&id=42f9bea4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports